import { Box, Typography } from "@material-ui/core";
import { useState, useEffect } from "react";
import useStyles from '../../assets/styles/styles';
import { useDispatch, useSelector } from "react-redux";
import { getEvolutionsDetailByAction } from "../../redux/actions/appointmentsActions";



const DetailEvolution = ({ evolutionId }) => {
    const classes = useStyles();
    const dispatch = useDispatch();  
    const modelEvolutionsByReducer = useSelector(state => state.appointmentsReducer);
    const modelByEvolutions = modelEvolutionsByReducer?.evolutionsByDetail?.find(evo => evo.id === evolutionId);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 760);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 760);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        dispatch(getEvolutionsDetailByAction());
    }, []);

    const fields = [
        {
            label: "DIAGNÓSTICO",
            value: modelByEvolutions?.diagnostico,
            condition: !!modelByEvolutions?.diagnostico,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "FECHA DE ATENCIÓN",
            value: modelByEvolutions?.fechaAtencion,
            condition: !!modelByEvolutions?.fechaAtencion,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "NOTAS CLÍNICAS / OBSERVACIONES",
            value: modelByEvolutions?.notasClinicas,
            condition: !!modelByEvolutions?.notasClinicas,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "PRESCRIPCIONES",
            value: modelByEvolutions?.prescripciones,
            condition: modelByEvolutions?.prescripciones?.length > 0,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "PROFESIONAL",
            value: modelByEvolutions?.profesional,
            condition: !!modelByEvolutions?.profesional,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "ESPECIALIDAD",
            value: modelByEvolutions?.especialidad,
            condition: !!modelByEvolutions?.especialidad,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
    ];

    const splitText = (text, wordLimit) => {
        if (typeof text !== 'string') return [];
        const descriptionEvolution = text.split(' ');
        const result = [];
        let currentLine = [];
        descriptionEvolution.forEach((word) => {
            currentLine.push(word);
            if (currentLine.length >= wordLimit) {
                result.push(currentLine.join(' '));
                currentLine = [];
            }
        });

        if (currentLine.length > 0) {
            result.push(currentLine.join(' '));
        }
        return result;
    };

    return (
        <>
            <Box className={`${classes.boxContent}`}>
                <>
                    <Box style={{ marginBottom: '10px' }}>
                        <Typography className={`${classes.txtCardDescription} ${classes.titleDetailEvolution}`}>
                            Datos de Evolución
                        </Typography>
                    </Box>

                    {fields.map((field, index) => (
                        field.condition && (
                            <Box key={index} style={{ marginBottom: "10px" }}>
                                <Typography className={field.labelClass}>{field.label}</Typography>
                                {isMobile
                                    ? splitText(field.value, 6).map((line, lineIndex) => (
                                        <Typography key={lineIndex} className={field.valueStyle}>{line}</Typography>
                                    ))
                                    : <Typography className={field.valueStyle}>{field.value}</Typography>
                                }
                            </Box>
                        )
                    ))}
                </>
            </Box>
        </>
    );
};

export default DetailEvolution;
